import { Button } from "@mui/material";

const MyButton = ({ children, onClick, variant = "contained", color = "primary", ...props }) => {
    return (
        <Button
            variant={variant}
            color={color}
            onClick={onClick}
            sx={{
                height: '2.5rem',
                borderRadius: '1.25rem',
                boxShadow: 'none',
                fontSize: '14px',
                textTransform: 'uppercase',
                padding: '0 2rem',
                ...props.sx,
            }}
            {...props}
        >
            {children}
        </Button>
    );
};

export default MyButton;

